class Slideshow {
  constructor(id, config) {
    this.id = id;
    this.selector = `[mb-splide-id="${this.id}"]`;
    this.config = config;

    this.element = null;
    this.slider = null;
  }

  #addInnerHTML(button, label, showArrow) {
    if (!showArrow) {
      button.innerText = label;
    } else {
      const iconString = `
        <svg class="mb-icon mb-icon--arrow" fill="currentColor" viewBox="0 0 9.75 9.75">
          <path d="M1.93,0c-.41,0-.75.34-.75.75s.34.75.75.75h5.26L.22,8.47c-.29.29-.29.77,0,1.06.29.29.77.29,1.06,0l6.97-6.97v5.26c0,.41.34.75.75.75s.75-.34.75-.75V.75c0-.11-.02-.21-.06-.31-.03-.06-.07-.12-.11-.18-.07-.08-.15-.14-.24-.19-.1-.05-.21-.07-.33-.07H1.93Z"/>
        </svg>
      `;

      const labelWrapper = document.createElement('span');
      const iconWrapper = document.createElement('span');

      labelWrapper.classList.add('mb-button__label');
      iconWrapper.classList.add('mb-button__arrow');

      labelWrapper.appendChild(document.createTextNode(label));
      iconWrapper.innerHTML = iconString;

      button.appendChild(labelWrapper);
      button.appendChild(iconWrapper);
    }
  }

  #buildPagination(data) {
    if (this.config.paginationType === 'numbers') {
      data.items.forEach((item) => {
        item.button.textContent = item.page + 1;
      });
    } else if (this.config.paginationType === 'buttons') {
      const slides = this.slider.Components.Elements.slides;
      const dataset = data.list.dataset;
      const buttonStyle = dataset.splideButtonStyle;
      const showArrow = dataset.splideShowArrow === 'true';
      const arrowPosition = dataset.splideArrowPosition;

      data.items.forEach((item) => {
        const target = slides[item.page];
        let label = target.dataset.paginationLabel;

        if (label === undefined) {
          label = 'ERROR! No label found';
        }

        const button = item.button;
        button.classList.add('mb-button', 'size-label');
        button.setAttribute('mb-variant', buttonStyle);

        if (showArrow) {
          button.classList.add('mb-button--show-arrow', `mb-button--arrow-${arrowPosition}`);
        }

        this.#addInnerHTML(button, label, showArrow);
      })
    }
  }

  init() {
    this.element = document.querySelector(this.selector);

    if (!this.element) {
      console.error(`Slideshow element with id ${this.id} not found`);
      return;
    }

    this.slider = new Splide(`${this.selector} .splide`, {
      type: this.config.loop,
      speed: this.config.duration,
      perPage: this.config.slidesToShow,
      perMove: 1,
      gap: this.config.gap,
      autoplay: this.config.autoplay,
      interval: this.config.interval,
      pauseOnHover: this.config.pauseOnHover,
      pauseOnFocus: this.config.pauseOnHover,
      pagination: this.config.pagination,
      arrows: this.config.navigation,
      drag: this.config.drag,
      snap: this.config.snapping,
      breakpoints: {
        990: {
          perPage: 1,
          perMove: 1,
        }
      }
    });

    if (this.config.paginationType === 'numbers' || this.config.paginationType === 'buttons') {
      this.slider.on('pagination:mounted', this.#buildPagination.bind(this));
    }

    this.slider.mount();
  }
}

export default Slideshow;